import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
type SocialPost = {
  image: string;
  alt: string;
  featured?: boolean;
};
const INSTAGRAM_URL = 'https://instagram.com/thisisneurospice';
const socialPosts: SocialPost[] = [{
  image: 'https://cdn.magicpatterns.com/uploads/uUmHNsNFDd6qokU6wa3N6h/use_cases_collage_.png',
  alt: 'Collage of NeuroSpice use cases: Virgin Mary, shakshuka, pizza and salted brownie',
  featured: true
}, {
  image: 'https://cdn.magicpatterns.com/uploads/2Kp6hwP7Bx17yXgSMLHC1K/Fries_with_Function_Hero_Energy.png',
  alt: 'Energy blend falling onto golden fries'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5r2sFwtfK19vakdNCpZTza/Curry_Wurst_x_ENERGY_blend_.png',
  alt: 'Energy blend poured over currywurst'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/mc84unMW7NUdzSJu1ei5t4/IMG_7296.jpg',
  alt: 'Rest, Energy and Focus tins on a counter with spice spilled'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/15XekjX4aBTRDddPQeRC6c/Popcorn_x_REST_blend_.png',
  alt: 'Hand sprinkling Rest blend over popcorn'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/mHDwaFKTHo2wtmBMNxAV61/Shakshouka_x_ENERGY_blend_.png',
  alt: 'Energy blend poured over shakshuka'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/8jJPEiv5FYhV4cY6cG9iVp/Virgin_Mary_x_REST_Blend_.png',
  alt: 'Virgin Mary rimmed with Rest salt and reishi'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/mKKRAh1WKkjVfGpaJsLDbB/IMG_7279.jpg',
  alt: 'Energy tin with a line of paprika and cordyceps blend'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/myG37TDhLgDXgLCTX3LLJX/BFN_Cinnamon_Swirl_Use_Case.jpg',
  alt: 'Focus blend sprinkled over a cinnamon swirl'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/by2y4BCXMhR33hMURCrKDz/Popcorn_(evening_2)_REST_blend_.png',
  alt: 'Rest tin and popcorn by candlelight'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/nuPXYwzBrn5zrkGrxiaseW/IMG_7300.jpg',
  alt: 'Rest tin beside a Berlin pretzel'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/8qg6Nc3yv5vDEb4L9jqqrb/IMG_7281.jpg',
  alt: 'Focus, Energy and Rest tins with spice swatches'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/4ThRZdSxLsytUoFmWGHgfb/BFN_use_case_virgin_mary.jpg',
  alt: 'Virgin Mary with a spiced rim'
}];
export function SocialFooter() {
  const {
    t
  } = useLanguage();
  return <section className="w-full py-20 px-6 bg-white border-t-2 border-black" data-id="element-353" data-mp="3je3klnzh292k">
      <div className="max-w-6xl mx-auto" data-id="element-354" data-mp="3eg1zkxihjzog">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-355" data-mp="3eh3mbz8v6am0">
          <h3 className="text-4xl md:text-6xl font-black text-black mb-4 uppercase tracking-tighter" data-id="element-356" data-mp="1cmkw861e1kzi">
            {t('social.title')}
          </h3>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="text-gray-600 font-mono hover:text-black transition-colors duration-150" data-id="element-357" data-mp="1p5zpuudu43wm">
            {t('social.handle')}
          </a>
        </motion.div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-358" data-mp="119vo0cegf3vs">
          {socialPosts.map((post, index) => <motion.a key={post.image} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label={`${post.alt} (opens Instagram)`} initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(index * 0.04, 0.4)
        }} className={`relative aspect-square overflow-hidden border-2 border-black group ${post.featured ? 'col-span-2 row-span-2' : ''}`} data-id="element-359" data-mp="168yk37cghzrm" data-mpi={index}>
              <img src={post.image} alt={post.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-300 ease-out group-hover:scale-105" data-id="element-360" data-mp="2z62e1xczphgj" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-colors duration-200 flex items-center justify-center" data-id="element-361" data-mp="383cstsp0noq7">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="opacity-0 group-hover:opacity-100 transition-opacity duration-200" data-id="element-362" data-mp="3huh6mp2yh3jg">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-363" data-mp="9bozm705at0d" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-364" data-mp="ebtextpbhhp0" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-365" data-mp="c1tx90dv11i" />
                </svg>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}